(function (angular) {
  "use strict";

  angular.module("Toyota.Services").service("DebugLogger", [
    "$window",
    "UrlParser",
    function ($window, UrlParser) {
      var exports = this;
      var enabled = !!UrlParser.queryStringToMapFromUrl(window.location.href)
        .debug;
      var groupWithStackTrace = false; // set to false to make filtering in Chrome work as expected

      exports.topicFilters = {
        all: function () {
          return true;
        },
      };

      exports.topicFilter = exports.topicFilters.all;

      exports.log = function (topic) {
        if (!exports.topicFilter(topic) || !enabled) {
          return;
        }

        function getErrorObject() {
          try {
            throw Error("");
          } catch (err) {
            return err;
          }
        }

        var datetime = new Date();

        /* eslint-disable no-magic-numbers */
        // eslint-disable-next-line no-unused-vars
        var timestamp =
          ("00" + datetime.getHours()).slice(-2) +
          ":" +
          ("00" + datetime.getMinutes()).slice(-2) +
          ":" +
          ("00" + datetime.getSeconds()).slice(-2) +
          "." +
          ("000" + datetime.getMilliseconds()).slice(-3);
        /* eslint-enable no-magic-numbers */

        /* eslint-disable no-eval */
        /* eslint-disable no-console */
        // Eval is needed here for console-fu
        if (groupWithStackTrace) {
          eval(
            "console.groupCollapsed.apply(this, [timestamp, topic].concat(Array.prototype.slice.call(arguments, 1))); \n//# sourceURL=log"
          );

          // eslint-disable-next-line no-unused-vars
          var err = getErrorObject();
          eval("console.log(err.stack.split('\\n').slice(3).join('\\n')); \n//# sourceURL=log");
          console.groupEnd();
        } else {
          eval(
            "console.log.apply(this, [timestamp, topic].concat(Array.prototype.slice.call(arguments, 1))); \n//# sourceURL=log"
          );
        }
        /* eslint-enable no-console */
        /* eslint-enable no-eval */
      };

      return exports;
    },
  ]);
})(window.angular);
